import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * The PDP badge (blocks/pdp-tags.liquid).
 * The badge depends on the selected variant ("Save X%", "Final Sale: Save X%"),
 * so this component listens for variant update events and swaps in the badge
 * from the re-rendered section, the same way product-price.js updates the price.
 */
class PdpBadges extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  /**
   * Replaces the badge with the one rendered for the newly selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadges = event.detail.data.html.querySelector(`pdp-badges[data-block-id="${this.dataset.blockId}"]`);
    if (!newBadges) return;

    this.innerHTML = newBadges.innerHTML;
  };
}

if (!customElements.get('pdp-badges')) {
  customElements.define('pdp-badges', PdpBadges);
}
